import { push } from '@lagunovsky/redux-react-router'
import { Grid } from '@mui/material'
import HomeAction from 'home/actions/HomeAction'
import { isUndefined } from 'lodash'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import i18n from 'simple-react-i18n'
import { hasValue } from 'utils/NumberUtil'
import { H_MAT_ANTENNA } from '../../../../account/constants/AccessRulesConstants'
import { PATH_MATERIEL_ANTENNA } from '../../../../home/constants/RouteConstants'
import ReferencialAppList from '../../../../referencial/components/ReferencialAppList'
import { getDate } from '../../../../utils/DateUtil'
import { componentHasHabilitations } from '../../../../utils/HabilitationUtil'
import { createIconMaterialState, getAssignmentLabel } from '../../../../utils/MaterielUtils'
import MaterielAssignmentLink from '../../MaterielAssignmentLink'
import { getLabel } from '../../../../utils/StoreUtils'
import { searchAllCharacters } from '../../../../utils/StringUtil'
import { LIST_PANEL, MAP_PANEL, MAT_HEADERS_ANTENNA } from '../../../constants/MaterielConstants'
import MaterielFilterForm from '../../filterPanel/MaterielFilterForm'
import MaterielsMapComponent from '../../map/MaterielsMapComponent'
import AntennaAction from '../actions/AntennaAction'
import { STATION_TYPE_CONSTANT } from '../../../../station/constants/StationConstants'

const AntennasApp = () => {
    const { search } = useLocation()

    const [view, setView] = useState(LIST_PANEL)
    const [filter, setFilter] = useState(() => {
        const { idType } = queryString.parse(search)
        return {
            matType: isUndefined(idType) ? undefined : parseInt(idType),
        }
    })

    const antennas = useSelector(store => store.AntennaReducer.antennas)
    const antennaTypes = useSelector(store => store.AntennaReducer.antennaTypes)
    const antennasLastSituations = useSelector(store => store.AntennaReducer.antennasLastSituations)
    const piezometers = useSelector(store => store.PiezometryReducer.piezometersLight)
    const pluviometers = useSelector(store => store.PluviometryReducer.pluviometers)
    const qualitometers = useSelector(store => store.QualityReducer.qualitometersLight)
    const hydrometricStations = useSelector(store => store.HydrometryReducer.hydrometricStations)
    const installations = useSelector(store => store.InstallationReducer.installations)
    const materielStates = useSelector(store => store.MaterielReducer.materielStates)
    const cities = useSelector(store => store.CityReducer.cities)
    const contributors = useSelector(store => store.ContributorReducer.contributors)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_MAT_ANTENNA)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(HomeAction.setHelpLink('materiel', ''))
        dispatch(AntennaAction.fetchAntennaTypes())
        if (!antennas.length) {
            dispatch(AntennaAction.fetchAntennas())
        }
    }, [])

    const getHash = mat => searchAllCharacters(MAT_HEADERS_ANTENNA.map(key => mat[key]).join(''))

    const getFilterMateriels = materiels => {
        const {
            network,
            state,
            administrator,
            manufacturer,
            searchValue,
            displayOutOfService,
        } = filter
        const filterAdministrator = administrator ? materiels.filter(({ administratorId }) => administrator === administratorId) : materiels
        const filterManufacturer = manufacturer ? filterAdministrator.filter(({ manufacturerId }) => manufacturer === manufacturerId) : filterAdministrator
        const filterStatusCode = hasValue(state) ? filterManufacturer.filter(({ statusCode }) => statusCode === state) : filterManufacturer
        const filterNetwork = network ? filterStatusCode.filter(({ networkCode }) => network === networkCode) : filterStatusCode
        const filterOutOfService = displayOutOfService ? filterNetwork : filterNetwork.filter(({ statusCode }) => statusCode !== 0 && statusCode !== 5 && statusCode !== 6)
        const searchValueFormated = searchAllCharacters(searchValue)
        return searchValue ? filterOutOfService.filter(mat => getHash(mat).includes(searchValueFormated)) : filterOutOfService
    }

    const getExportData = (materiels) => {
        if (!materiels.length) {
            return []
        }
        const [head, ...tail] = materiels
        return [{ ...head, headers: MAT_HEADERS_ANTENNA }, ...tail]
    }

    const getCorrespondingSite = ({ siteType, siteCode }) => {
        switch (siteType) {
            case STATION_TYPE_CONSTANT.PIEZOMETRY:
                return piezometers.find(({ id }) => id === siteCode)
            case STATION_TYPE_CONSTANT.PLUVIOMETRY:
                return pluviometers.find(({ id }) => id === siteCode)
            case STATION_TYPE_CONSTANT.QUALITY:
                return qualitometers.find(({ id }) => id === siteCode)
            case STATION_TYPE_CONSTANT.HYDROMETRY:
                return hydrometricStations.find(({ id }) => id === siteCode)
            case STATION_TYPE_CONSTANT.INSTALLATION:
                return installations.find(({ id }) => id === siteCode)
            default:
                return {}
        }
    }

    const getPanel = antennasList => {
        if (view === MAP_PANEL) {
            return (
                <MaterielsMapComponent
                    materiels={ antennasList }
                    materielLink={ PATH_MATERIEL_ANTENNA }
                    singularTitle={ i18n.antenna }
                />
            )
        }
        const formattedData = antennasList.map(mat => ({
            ...mat,
            state: createIconMaterialState(mat.state, mat.statusCode),
            assignment: <MaterielAssignmentLink materiel={mat} />,
        }))
        return (
            <ReferencialAppList
                title={ i18n.antennas }
                data={ formattedData }
                exportData={ getExportData(antennasList) }
                type={{ headers: MAT_HEADERS_ANTENNA }}
                newAction={() => dispatch(push('/materiel/antenna/new'))}
                showNewButton
                showPurgeButton={false}
                setTitleAction={HomeAction.setTitle([{
                    title: i18n.materiel,
                    href: 'materiel',
                }, {
                    title: i18n.antennas,
                    href: 'materiel/antenna',
                }])}
                onClick={({ materielId }) => dispatch(push(`/materiel/antenna/${materielId}`))}
                searchable={false}
            />
        )
    }

    const materiels = antennas.map(mat => {
        const lastSituation = antennasLastSituations.find(s => s.idAntenne === mat.id)
        const labelState = lastSituation ? getLabel(materielStates, lastSituation.statusCode) : ''
        const site = lastSituation && lastSituation.statusCode === 1 && lastSituation.siteType && lastSituation.siteCode && getCorrespondingSite(lastSituation) || {}
        const labelAssignment = (lastSituation && lastSituation.statusCode === 1 && getAssignmentLabel(site, lastSituation.siteName)) || ''
        const city = site.townCode && cities.find((o) => o.code === site.townCode) || undefined
        const cityLabel = city ? `${city.name} - [${city.code}]` : (site.townCode || '')
        const departmentLabel = city && city.departmentNumber ? city.departmentNumber : ''
        return {
            materielId: mat.id,
            type: getLabel(antennaTypes, mat.materielType),
            manufacturer: getLabel(contributors, mat.manufacturerId, 'labelDisplay', 'id'),
            state: labelState,
            statusCode: lastSituation && lastSituation.statusCode,
            stateDate: lastSituation && getDate(lastSituation.situationDate),
            city: cityLabel,
            administratorId: mat.administrator,
            serialNumber: mat.serialNumber,
            immoNum: mat.code,
            name: mat.name,
            assignment: labelAssignment,
            siteType: lastSituation && lastSituation.siteType,
            departmentShort: departmentLabel,
            purchaseDate: getDate(mat.purchaseDate),
            manufacturerId: mat.manufacturerId,
            networkCode: mat.networkCode,
            siteCode: lastSituation && lastSituation.siteCode,
            administrator: getLabel(contributors, mat.administrator, 'labelDisplay', 'code'),
        }
    })
    const filteredMateriels = getFilterMateriels(materiels)
    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <MaterielFilterForm
                    view={view}
                    filter={filter}
                    changeView={setView}
                    materiels={materiels}
                    typeList={[]}
                    onValidate={setFilter}
                    materielType='ANTENNA'
                />
            </Grid>
            <Grid size={12}>
                {getPanel(filteredMateriels)}
            </Grid>
        </Grid>
    )
}

export default AntennasApp
